import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from "react";
import './Checkbox.scss';
import { Form } from 'react-bootstrap';

const Checkboxes = ({
  fieldData,
  value,
  onChange,
  disabled,
  name,
  id,
  formLabel,
  required,
  error,
  ...props
}) => {
  const [currentValue, setValue] = useState((value) ? value : []);
  useEffect(() => setValue(value), [value]);


  const handleClick = useCallback((e) => {
    if (e.target.tagName === 'A') return;
    let newValue = currentValue;
    if (e.target.checked) {
      newValue.push(e.target.value);
    } else {
      const index = newValue.indexOf(e.target.value);
      if (index > -1) {
        newValue.splice(index, 1);
      }
    }
    setValue(newValue);
    if (onChange) {
      onChange(e, { values: currentValue });
    }

  }, [onChange, currentValue]);

  const checkbox = useCallback((option, disabled) => {
    const iconStatus = (currentValue && (currentValue.includes(option.id) || currentValue.includes(String(option.id)))) ? 'fa-check' : null;
    const checkboxStatus = (iconStatus) ? 'checked' : null;
    return (
      <div key={option.id} className={classNames("checkbox", { disabled })}>
        <div className={classNames('checker', checkboxStatus)}>
          <input type="checkbox"
            name={name}
            disabled={disabled}
            id={option.id}
            value={option.id}
            defaultChecked={iconStatus}
            onClick={handleClick}
            {...props}
          />
          {iconStatus && <i className={classNames("fal", iconStatus)}></i>}
        </div>
        {option.label && <label className='form-label' htmlFor={option.id}>{option.label}</label>}
      </div>
    );
  }, [currentValue]);

  return (
    <Form.Group>
      <Form.Label
        htmlFor={fieldData.code}
        required={required}>
        {formLabel || fieldData.label}
      </Form.Label>
      {fieldData.options.map(option => (
        checkbox(option, disabled)
      ))}
      {error && <Form.Text className="text-muted danger-text">
        {error}
      </Form.Text>}
    </Form.Group>
  );
};

Checkboxes.propTypes = {
  fieldData: PropTypes.object,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  formLabel: PropTypes.any,
};

Checkboxes.defaultProps = {
  value: false,
  onChange: null,
  disabled: false,
  name: null,
  id: null,
  required: false,
  error: null,
  formLabel: null
};
export default React.memo(Checkboxes);
